module.exports = __webpack_public_path__ + "img/Bs.54b61935.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/shot-images/Bs.jpg
// module id = bHgG
// module chunks = 1